import React from "react";
import { useTranslation } from "react-i18next";

export default function ConfirmDeleteModal({label, deleteUser,cancelRequest, id ,btnLabel}) {
  const { t } = useTranslation("mediumBooking");
  return (
    <div className="confirm-delete-wrapper booking-modal-confirm register-medium">
      <div data-backdrop="static" className="modal fade" id={id} role="dialog">
        <div className="modal-dialog">
          <div className="modal-content">
            <div className="modal-body">
              <div className="icon-pop">
                <img src="images/Union-icon.png" alt="Union-icon" />
              </div>
              <h3>{label}</h3>
              <div className="confirm-btn-box">
                <div
                  className="register-medium-confirnation"
                  onClick={cancelRequest}
                  data-dismiss="modal"
                >
                  {t("actions.cancel")}
                </div>
                <div
                  className="register-medium-confirnation"
                  data-dismiss="modal"
                  onClick={deleteUser}
                >
                  {btnLabel}
                </div>
              </div>
            </div>
          </div>
        </div>
      </div>
    </div>
  );
}
